import { BatchHttpLink } from "apollo-link-batch-http";
import { onError } from "apollo-link-error";

import { GRAPHQL_ROOT } from "config/constants";
import Log from "utils/log";

/*
  onError receives a callback in the event a GraphQL or network error occurs.
  @TODO: Connect this to Sentry.
*/
export const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, location, path }) =>
      Log.error(
        `[GraphQL error]: Message: ${message}, Location: ${location}, Path: ${path}`
      )
    );
  if (networkError) Log.error(`[Network error]: ${networkError}`);
});

export const apiLink = (config) => (
  new BatchHttpLink({
    uri: GRAPHQL_ROOT,
    ...config || {},
  })
);
